<template>
    <div>
        <ContactNoSaveWindow @confirmNext="confirmNext"/>
        <SaveWindow text="Данные успешно сохранены"/>

        <div class="layout">
            <div class="cabinet-page_bg"></div>

            <HeaderAuth/>
            <div class="cabinet-content-block-wrapper">
                <div class="cabinet-content-block">

                    <ClientNavigation/>
                    <div class="cabinet-content">
                        <div class="heading-wrapper">
                            <div class="title" v-html="$ml.with('VueJS').get('contactFaces')"></div>
                        </div>
                        <div v-if="!locked" class="cabinet-content-inner">

                            <div class="cabinet-text">
                                <p>Укажите данные по крайней мере двух контактных лиц, которым Вы доверяете. Это нужно для того, чтобы мы могли с ними связаться, если связь с Вами будет невозможна по тем или иным причинам.</p>
                            </div>

                            <div class="form">
                                <DeleteContactWindow @removeContact="confirmRemove"/>
                                <section v-for="contact in contactList" :key="contactList.indexOf(contact)" class="form-section form-wrap">
                                    <button v-show="contact.canDelete" :key="contactList.indexOf(contact)" @click="deleteContact(contactList.indexOf(contact))" class="delete-section">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
                                    </button>
                                    <div class="title">Контактное лицо №{{contactList.indexOf(contact) + 1}}</div>
                                    <div class="form-field-input-2"
                                         :class="{'error-field' : contact.validationErrors.surname}"
                                    >
                                        <label>Фамилия&nbsp;*</label>
                                        <div class="field-input-wrapper">
                                            <input v-model.trim="contact.surname"
                                                   :name="'surname' + contactList.indexOf(contact)"
                                                   ref="surname"
                                                   type="text"
                                                   v-validate="'required'"
                                                   autocomplete="off"
                                                   @input="surnameInput(contactList.indexOf(contact))"
                                            >
                                            <div v-show="contact.validationErrors.surname" class="msg-form msg-error-field">
                                                Заполните обязательное поле
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-field-input-2"
                                         :class="{'error-field' : contact.validationErrors.nameAndPatronymic}"
                                    >
                                        <label>Имя и Отчество&nbsp;*</label>
                                        <div class="field-input-wrapper">
                                            <input v-model.trim="contact.nameAndPatronymic"
                                                   :name="'nameAndPatronymic' + contactList.indexOf(contact)"
                                                   ref="nameAndPatronymic"
                                                   type="text"
                                                   v-validate="'required'"
                                                   autocomplete="off"
                                                   @input="nameInput(contactList.indexOf(contact))"
                                            >
                                            <div v-show="contact.validationErrors.nameAndPatronymic" class="msg-form msg-error-field">
                                                Заполните обязательное поле
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-field-input-2"
                                         :class="{'error-field' : contact.validationErrors.email}"
                                    >
                                        <label>Email&nbsp;*</label>
                                        <div class="field-input-wrapper">
                                            <input v-model.trim="contact.email"
                                                   :name="'email' + contactList.indexOf(contact)"
                                                   type="text"
                                                   autocomplete="off"
                                                   ref="email"
                                                   v-validate="'required|email'"
                                                   @input="emailInput(contactList.indexOf(contact))"
                                            >
                                            <div v-show="contact.validationErrors.email" class="msg-form msg-error-field">
                                                Введите адрес электронной почты
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-field-input-2"
                                         :class="{'error-field' : contact.validationErrors.phone}"
                                    >
                                        <label>Номер телефона&nbsp;*</label>
                                        <div class="field-input-wrapper">
                                            <vue-tel-input v-model="contact.phone"
                                                           :inputId="'' + contactList.indexOf(contact)"
                                                           :wrapperClasses="{'dev_error_tel_input' : contact.validationErrors.phone}"
                                                           placeholder="Введите номер телефона"
                                                           :name="'phone' + contactList.indexOf(contact)"
                                                           v-validate="'required'"
                                                           @onInput="phoneInput($event, contactList.indexOf(contact))"
                                                           @country-changed="countryChanged($event, contactList.indexOf(contact))"
                                                           @validate="phoneValidate($event, contactList.indexOf(contact))"
                                                           :ref="'phoneNumber' + contactList.indexOf(contact)"
                                            ></vue-tel-input>
                                            <div v-show="contact.validationErrors.phone" class="msg-form msg-error-field">
                                                {{contact.validationErrors.phoneMessage}}
                                            </div>
                                        </div>
                                    </div>

                                    <div v-for="link in contact.links" class="form-field-input-2">
                                        <label>Дополнительный канал связи</label>
                                        <div class="field-input-wrapper">
                                            <input v-model="link.data"
                                                   type="text"
                                                   required=""
                                                   @input="isChanged = true"
                                            >

                                            <div class="msg-form">Введите дополнительный номер телефона, email или любой другой канал, по&nbsp;которому мы&nbsp;можем связаться с&nbsp;данным контактным лицом</div>
                                        </div>
                                        <button @click="deleteLink(contact, link)" class="button-del-field" title="Удалить дополнительный канал связи">
                                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.05025 7.05024L16.9497 16.9497M16.9497 7.05024L7.05025 16.9497" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                        </button>
                                    </div>

                                    <button v-show="contact.links.length < 3" class="button-nobg-icon add-other-contact" @click="addLink(contact)">
                                        <span class="icon">
                                            <PlusIcon/>
                                        </span>
                                        <span class="text">Добавить канал связи</span>
                                    </button>
                                </section>

                                <button v-show="contactList.length < 5" @click="addContact" class="button-nobg-icon add-other-contact-item">
                                    <span class="icon"><PlusIcon/></span>
                                    <span class="text">Добавить контактное лицо</span>
                                </button>

                                <div class="button-block">
                                    <button class="button button-dark modal-save-contacts"
                                            :disabled="isBlocked || pressed"
                                            type="button"
                                            @click="save"
                                    >
                                        Сохранить
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        <FooterAuth/>
    </div>
</template>



<script>
    import HeaderAuth from "../components/HeaderAuth";
    import ClientNavigation from "../components/ClientNavigation";
    import FooterAuth from "../components/FooterAuth";
    import PlusIcon from "../components/icons/PlusIcon";
    import { VueTelInput } from 'vue-tel-input'
    import DeleteContactWindow from '../components/windows/DeleteContactWindow.vue';
    import ContactNoSaveWindow from '../components/windows/ContactNoSaveWindow.vue';
    import SaveWindow from '../components/windows/SaveWindow.vue';

    const notFilledMessage = 'Заполните обязательное поле';
    const phoneErrorMessage = 'Введите корректный номер телефона';

    export default {
        name: 'ClientContacts',
        components: {FooterAuth, ClientNavigation, HeaderAuth, PlusIcon, DeleteContactWindow, VueTelInput, ContactNoSaveWindow, SaveWindow},

        metaInfo: {
            title: 'Контактные лица | Your Last Word'
        },

        data() {
            return {
                contactList: [],
                contactToRemove: {},
                pressed: false,
                isChanged: false,
                next: {},
                inputOptions: {
                    showDialCode: true
                },
                subscribed: true,
                locked: false,
                defaultContact: {
                    id: 0,
                    surname: '',
                    nameAndPatronymic: '',
                    email: '',
                    phone: '',
                    links: [],
                    canDelete: false,
                    validationErrors: {
                        email: false,
                        phone: false,
                        surname: false,
                        nameAndPatronymic: false,
                        phoneMessage: ''
                    },
                    intlTelCountry: {},
                    intlTelNumber: {}
                }
            }
        },

        beforeCreate() {
            $('body').attr('class', 'cabinet-page');
            $('body').addClass('contacts-list-page');
        },

        beforeRouteLeave (to, from, next) {
            if (this.isChanged) {
                $('.window-wrapper.window-no-save-contacts').addClass('window-open');
                $('body').addClass('blocked');
                this.next = next;
            } else {
                next();
            }
        },

        async created() {


            this.contactList = [this.defaultContact, this.defaultContact];
            let newContactList = [];
            let contacts = await this.$store.dispatch('loadUserContacts');
            for (let i = 0; i < contacts.length; i++) {
                let canDelete = true;
                if (i < 2) {
                    canDelete = false;
                }
                let contact = {
                    id: contacts[i].id,
                    surname: contacts[i].surname,
                    nameAndPatronymic: contacts[i].name + ' ' + contacts[i].patronymic,
                    email: contacts[i].email,
                    phone: contacts[i].phone,
                    links: contacts[i].linkList,
                    canDelete: canDelete,
                    validationErrors: {
                        email: false,
                        phone: false,
                        surname: false,
                        nameAndPatronymic: false,
                        phoneMessage: ''
                    },
                    intlTelCountry: {},
                    intlTelNumber: {}
                };
                newContactList.push(contact);
            }

            if (contacts.length < 2) {
                for (let i = contacts.length; i < 2; i++) {
                    let contact = {
                        id: 0,
                        surname: '',
                        nameAndPatronymic: '',
                        email: '',
                        phone: '',
                        links: [],
                        canDelete: false,
                        validationErrors: {
                            email: false,
                            phone: false,
                            surname: false,
                            nameAndPatronymic: false,
                            phoneMessage: ''
                        },
                        intlTelCountry: {},
                        intlTelNumber: {}
                    }
                    newContactList.push(contact);
                }
            }

            this.contactList = newContactList;
        },

        computed: {
            isBlocked() {
                let blocked = false;
                this.contactList.forEach(contact => {
                    blocked = blocked || contact.phone.trim() === '' || contact.surname.trim() === '' || contact.nameAndPatronymic.trim() === '' || contact.email.trim() === '';
                });

                return blocked && this.subscribed;
            }
        },

        methods: {
            addLink(contact) {
                contact.links.push({id: 0, data: ''});
            },

            deleteLink(contact, link) {
                const index = contact.links.indexOf(link);
                if (index > -1) {
                    contact.links.splice(index, 1);
                }
            },

            addContact() {
                let newContact = {
                    id: 0,
                    surname: '',
                    nameAndPatronymic: '',
                    email: '',
                    phone: '',
                    links: [],
                    canDelete: true,
                    validationErrors: {
                        email: false,
                        phone: false,
                        surname: false,
                        nameAndPatronymic: false,
                        phoneMessage: ''
                    },
                    intlTelCountry: {},
                    intlTelNumber: {},
                    defaultCountry: 'RU'
                };

                this.contactList.push(newContact);
            },

            deleteContact(contactIndex) {
                let contact = this.contactList[contactIndex];
                this.contactToRemove = contact;
                if (contact.surname.trim() !== '' || contact.nameAndPatronymic !== '' || contact.email !== '' || contact.phone !== '' || contact.links.length !== 0) {
                    $('.window-wrapper.window-contact-section-delete').addClass('window-open');
                    $('body').addClass('blocked');
                } else {
                    this.confirmRemove();
                }
            },

            confirmRemove() {
                const index = this.contactList.indexOf(this.contactToRemove);
                if (index > -1) {
                    this.contactList.splice(index, 1);
                }
            },

            confirmNext() {
                this.next();
            },

            async save() {
                this.pressed = true;
                let errors = false;

                for (let i = 0; i < this.contactList.length; i++) {
                    if (this.errors.has('email' + i)) {
                        this.contactList[i].validationErrors.email = true;
                        errors = true;
                    }


                    if (!$.isEmptyObject(this.contactList[i].intlTelNumber) && !this.contactList[i].intlTelNumber.isValid) {
                        this.contactList[i].validationErrors.phone = true;
                        this.contactList[i].validationErrors.phoneMessage = phoneErrorMessage;
                        errors = true;
                    }

                    if (this.contactList[i].phone.trim() === '') {
                        this.contactList[i].validationErrors.phone = true;
                        this.contactList[i].validationErrors.phoneMessage = notFilledMessage;
                        errors = true;
                    }

                    if (this.contactList[i].surname.trim() === '') {
                        this.contactList[i].validationErrors.surname = true;
                        errors = true;
                    }

                    if (this.contactList[i].nameAndPatronymic.trim() === '') {
                        this.contactList[i].validationErrors.nameAndPatronymic = true;
                        errors = true;
                    }
                }

                if (!errors) {
                    let contacts = [];
                    this.contactList.forEach(contact => {
                        let names = contact.nameAndPatronymic.split(' ');
                        let contactToSave = {
                            id: contact.id,
                            surname: contact.surname,
                            name: names.length > 1 ? names.slice(0, -1).join(' ') : names[0],
                            patronymic: names.length > 1 ? names.slice(-1).join(' ') : '',
                            email: contact.email,
                            phone: contact.intlTelNumber.number.international,
                            linkList: contact.links
                        };
                        contacts.push(contactToSave)
                    });

                    let success = await this.$store.dispatch('saveContactList', contacts);

                    if (!!success) {
                        $('body').addClass('blocked');
                        this.isChanged = false;

                        $('.window-wrapper.window-save-contacts').addClass('window-open');
                        $('body').addClass('blocked');
                    }
                }
                this.pressed = false;

            },

            phoneInput(event, contactIndex) {
                this.isChanged = true;
                this.contactList[contactIndex].intlTelNumber = {number: event.number, isValid: event.isValid};

                this.contactList[contactIndex].validationErrors.phone = this.contactList[contactIndex].phone.trim() === '' && this.subscribed;
                if (this.contactList[contactIndex].validationErrors.phone) {
                    this.contactList[contactIndex].validationErrors.phoneMessage = notFilledMessage;
                }

                if (event.number.international) {
                    let index = event.number.international.indexOf(" ");
                    this.contactList[contactIndex].phone = event.number.international.slice(index + 1);
                }
            },
            countryChanged(event, contactIndex) {
                this.contactList[contactIndex].intlTelCountry = event;
                this.contactList[contactIndex].defaultCountry = event.iso2;
                this.$refs['phoneNumber' + contactIndex][0].choose(this.contactList[contactIndex].defaultCountry);

                if (this.contactList[contactIndex].phone && this.contactList[contactIndex].phone.includes("+")) {
                    this.contactList[contactIndex].phone = this.contactList[contactIndex].phone.replace("+".concat(event.dialCode), "");
                }
            },
            phoneValidate(event, contactIndex) {
                this.contactList[contactIndex].intlTelNumber = {number: event.number, isValid: event.isValid};
                if (event.isValid) {
                    this.contactList[contactIndex].defaultCountry = event.regionCode;
                    this.$refs['phoneNumber' + contactIndex][0].choose(event.regionCode);
                }

                if (event.number.international) {
                    let index = event.number.international.indexOf(" ");
                    this.contactList[contactIndex].phone = event.number.international.slice(index + 1);
                }
            },
            surnameInput(contactIndex) {
                this.isChanged = true;

                this.contactList[contactIndex].validationErrors.surname = this.contactList[contactIndex].surname.trim() === '' && this.subscribed;
            },
            nameInput(contactIndex) {
                this.isChanged = true;

                this.contactList[contactIndex].validationErrors.nameAndPatronymic = this.contactList[contactIndex].nameAndPatronymic.trim() === '' && this.subscribed;
            },
            emailInput(contactIndex) {
                this.isChanged = true;

                this.contactList[contactIndex].validationErrors.email = this.contactList[contactIndex].email.trim() === '' && this.subscribed;
            }
        }

    }
</script>

<style scoped>
    .dev_error_tel_input {
        border-color: #dd5656 !important;
        color: #dd5656;
    }

    .vti__dropdown {
        background-color: rgba(0, 0, 0, 0.05);
    }

    .vti__dropdown-item{
        color: #000 !important;
    }

    .vue-tel-input:focus-within {
        box-shadow: none !important;
        border-color: #000 !important;
    }
</style>
